module.exports = __webpack_public_path__ + "static/a-short-history-of-nearly-everything-special-illustrated-edition-13cff6d18483e1272d6c130b6613e22c.jpg";